import tbdcLogo from '../tbdc-logo1.1.png';
import fintechCadenceLogo from '../fintechcadence2-1.png';

// Text here mirrors public/content/partners.json, which the backend's
// server-rendered /about page and /llms.txt read. Keep both in sync; the logos
// only exist here because they are webpack imports.
export const partners = [
  {
    name: 'TBDC',
    focus: 'Business Incubator',
    description: 'Toronto Business Development Centre',
    relationship: 'KeyTa is an incubated company at the Toronto Business Development Centre.',
    url: 'https://tbdc.com/',
    profileUrl: 'https://tbdc.com/company/keyta/',
    profileLabel: 'KeyTa on TBDC',
    logo: tbdcLogo,
    logoAlt: 'TBDC (Toronto Business Development Centre) logo',
  },
  {
    name: 'Fintech Cadence',
    focus: 'Fintech Accelerator',
    description: 'Fintech Cadence',
    relationship: "KeyTa is part of Fintech Cadence, Canada's fintech hub and accelerator.",
    url: 'https://fintechcadence.com/',
    profileUrl: null,
    profileLabel: null,
    logo: fintechCadenceLogo,
    logoAlt: 'Fintech Cadence logo',
  },
];
